import { Box } from '@mui/material';
import { LabeledValue, LabeledValue_Label, LabeledValue_Value } from 'emerald-ui';
import React from 'react';
import {
    DataSubHeaderRow_CalendarIcon,
    DataSubHeaderRow_Root,
    DataSubHeaderRow_CargoIcon,
    DataSubHeaderRow_EmptyState
} from './DataSubHeaderRow.style';
import { staticUrl } from 'emerald-ui/dist/globals/urls';

/** @typedef {{ type: string, value: string }[]} DataSubHeaderRowDataProp */

/**
 * @typedef DataSubHeaderRowProps
 * @property {DataSubHeaderRowDataProp} [data]
 */

/** @type {(props: DataSubHeaderRowProps & React.HTMLAttributes<HTMLDListElement>) => JSX.Element} */
export function DataSubHeaderRow(props) {
    const {
        data = [],
        ...otherProps
    } = props;

    /** @type {React.ReactNode} */
    let icon = <DataSubHeaderRow_CalendarIcon />;
    if (data[0]?.type === 'Cargo Number') {
        icon = <DataSubHeaderRow_CargoIcon url={staticUrl('images/cargo.svg')} />;
    }

    let content;
    if (data.length) {
        content = data.map((item) => (
            <LabeledValue
                as='div'
                key={item.type}
            >
                <LabeledValue_Label>
                    {item.type}
                </LabeledValue_Label>
                <LabeledValue_Value>
                    {item.value || <abbr title='Not available'>n/a</abbr>}
                </LabeledValue_Value>
            </LabeledValue>
        ));
    } else {
        content = <DataSubHeaderRow_EmptyState>No dates added</DataSubHeaderRow_EmptyState>;
    }

    return (
        <DataSubHeaderRow_Root {...otherProps}>
            <Box
                sx={{ display: { xs: 'none', sm:'block' } }}
            >
                {icon}
            </Box>
            {content}
        </DataSubHeaderRow_Root>
    );
}
